import { useRoutes } from 'react-router';
import { routeTree } from './router';
import { PrivacyLayer } from '@features/privacy/PrivacyLayer';

export function App() {
  const routes = useRoutes(routeTree);
  return (
    <>
      {routes}
      {/* App-root, OUTSIDE the AuthGuard so it covers pre-auth pages too: runs the async geo/consent
          bootstrap, gates Hotjar on consent, and (F3) renders the consent banner. */}
      <PrivacyLayer />
    </>
  );
}
